// removed by extract-text-webpack-plugin
module.exports = {"project-preview":"VapHs70i","projectPreview":"VapHs70i","loading":"_18P9FgIy","spinner":"_3CP28k7M","loading-bar-spinner":"_1jKAfkgK","loadingBarSpinner":"_1jKAfkgK","spinner-icon":"_3Yrp5g8U","spinnerIcon":"_3Yrp5g8U","overlay":"_1h0vK76F","hero-wrap":"aabBeRbc","heroWrap":"aabBeRbc","hero":"_3Yk6djQY","img-wrap":"C7jZQrwr","imgWrap":"C7jZQrwr","title":"_2pDGGmU7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectPreview/ProjectPreview.pcss
// module id = 836
// module chunks = 0